import { render } from "./inviteHistoryBonus.vue?vue&type=template&id=0659b04a&scoped=true"
import script from "./inviteHistoryBonus.vue?vue&type=script&lang=js"
export * from "./inviteHistoryBonus.vue?vue&type=script&lang=js"

import "./inviteHistoryBonus.vue?vue&type=style&index=0&id=0659b04a&scoped=true&lang=css"

import exportComponent from "/home/runner/work/user-ui/user-ui/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0659b04a"]])

export default __exports__